// extracted by mini-css-extract-plugin
export default {"main":"OrderPage_main__TVzF2","sidebar":"OrderPage_sidebar__jeDJD"};